module.exports = __webpack_public_path__ + "img/10.cfa9906b.png";